function Loading() {
    return (
        <div className="text-center">
            <img src="/img/globe.gif" /><br/><br/>
        </div>
    );
}

export default Loading;
